import { Breadcrumbs, Card, Zoom } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Row, Col, CardBody, CardText, Table } from 'reactstrap';
import axios from '../axios';
import moment from 'moment';
import { format } from 'indian-number-format';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import ReactApexChart from 'react-apexcharts';

function DashboardPG() {
  useEffect(() => {

    var date = new Date();
    var firstday = new Date(date.getFullYear(), date.getMonth(), 1);
    // var lastday =  new Date(date.getFullYear(), date.getMonth()+1,0)
    var lastday = new Date(
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate(),
    );
    var lastdays = new Date(
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate(),
    );
    GetCustomerEnrolleddata();
    GetOutstanding();
    GetPOPendingdata();
    Getalltopsellingproducts();
    Gettopusers();
    Getallprofit();
    // setChartOptions({
    //   series: [{
    //     name: "Sales",
    //     data: [januaryproft, 41, 35, 51, 49, 62, 69, 91, 148]
    //   }],
    //   chart: {
    //     height: 350,
    //     type: 'line',
    //     zoom: {
    //       enabled: false
    //     }
    //   },
    //   dataLabels: {
    //     enabled: false
    //   },
    //   stroke: {
    //     curve: 'straight'
    //   },
    //   title: {
    //     text: 'Product Trends by Month',
    //     align: 'left'
    //   },
    //   grid: {
    //     row: {
    //       colors: ['#f3f3f3', 'transparent'],
    //       opacity: 0.5
    //     },
    //   },
    //   xaxis: {
    //     categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
    //   }
    // });
    PoCount(firstday, lastday);
  }, []);

  // const [chartOptions, setChartOptions] = useState(null);

  // customer enrolled
  const [customerenrolleddata, setcustomerenrolleddata] = useState([]);

  // Oustanding
  const [salesoutstanding, setsalesoutstanding] = useState('');

  // PendingPOApproval
  const [PendingPOApproval, setPendingPOApproval] = useState('');

  // FastMoving Item
  const [alltopsellingproudcts, setalltopsellingproudcts] = useState([]);

  // Top Customer
  const [allusers, setallusers] = useState([]);

  // saless analytics
  const [januaryproft, setjanuaryproft] = useState(0);
  const [feburprofit, setfeburprofit] = useState(0);
  const [marchprofit, setmarchprofit] = useState(0);
  const [aprilprofit, setaprilprofit] = useState(0);
  const [mayprofit, setmayprofit] = useState(0);
  const [juneprofit, setjuneprofit] = useState(0);
  const [julyproft, setjulyproft] = useState(0);
  const [augprofit, setaugprofit] = useState(0);
  const [sepprofit, setsepprofit] = useState(0);
  const [octprofit, setoctprofit] = useState(0);
  const [novprofit, setnovprofit] = useState(0);
  const [decprofit, setdecprofit] = useState(0);

  const [allprofitcollections, setallprofitcollections] = useState([]);
  const [completecouts, setcompletecouts] = useState('');
  const [statuscounsts, setstatuscounsts] = useState('');
  const [deliveredCounts, setdeliveredCounts] = useState('')

  const GetCustomerEnrolleddata = async () => {
    const tokent = sessionStorage.getItem('authtoken');
    const get = await axios.instance
      .get(`GetOneCompanyAccess/${sessionStorage.getItem('Companyid')}`, {
        headers: {
          Authorization: tokent,

          'Content-Type': 'application/json',
        },
      })
      .then(res => {
        setcustomerenrolleddata(res.data[0]);
        console.log(res.data);
      });
  };

  // Outstanding
  const GetOutstanding = async () => {
    const tokent = sessionStorage.getItem('authtoken');
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const get = await axios.instance
      .get(
        `Getsalesvaluefinaldash/${moment(firstDay).format('YYYYMMDD')}/${moment(
          new Date(),
        ).format('YYYYMMDD')}/${sessionStorage.getItem(
          'Companyid',
        )}/and ac.Group_Id in (27)`,
        {
          headers: {
            Authorization: tokent,

            'Content-Type': 'application/json',
          },
        },
      )
      .then(res => {
        for (const data of res.data) {
          // setsalesftdason(data.Cursales)
          // setsalesmtd(data.AsOnSales)
          // setcollectionftdason(data.CurCollected)
          // setcollectionmtd(data.AsOnCollected)
          setsalesoutstanding(data.CusBal);
        }
      });
  };

  // PO Pending
  const GetPOPendingdata = async () => {
    const tokent = sessionStorage.getItem('authtoken');
    const get = await axios.instance
      .get(`GetPendingPOApproval/${sessionStorage.getItem('Branch_Log')}`, {
        headers: {
          Authorization: tokent,
          'Content-Type': 'application/json',
        },
      })
      .then(res => {
        const pendingPOData = res.data;
        setPendingPOApproval(pendingPOData.length);
        console.log('pendingPOData', res.data.length);
      });
  };

  // Fastmoving item
  const Getalltopsellingproducts = async () => {
    const tokent = sessionStorage.getItem('authtoken');
    const get = await axios.instance
      .get(`Gettopsellingproducts/${sessionStorage.getItem('Companyid')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        console.log(res.data);

        setalltopsellingproudcts(res.data);
      });
  };

  // Top Customer
  const Gettopusers = async () => {
    const tokent = sessionStorage.getItem('authtoken');
    const get = await axios.instance
      .get(`/TopCustomer/${sessionStorage.getItem('Companyid')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        setallusers(res.data);
      });
  };

  console.log(januaryproft, 'jan');
  // Sales Analytics
  const Getallprofit = async () => {
    const tokent = sessionStorage.getItem('authtoken');
    const get = await axios.instance
      .get(`/GetSalesAnalytics/${sessionStorage.getItem('Companyid')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        console.log(res.data);
        for (const data of res.data) {
          ////console.log(data,)
          // setjanuaryproft(data.JanS)
          // setjanuaryproft(Math.round(data.JanS));
          // setfeburprofit(Math.round(data.FebS));
          // setmarchprofit(Math.round(data.MarchS));
          // setaprilprofit(Math.round(data.AprilS));
          // setjuneprofit(Math.round(data.JuneS));
          // setjulyproft(Math.round(data.JulyS));
          // setaugprofit(Math.round(data.AugestS));
          // setsepprofit(Math.round(data.SeptS));
          // setoctprofit(Math.round(data.OctS));
          // setnovprofit(Math.round(data.NovS));
          // setdecprofit(Math.round(data.DecS));
          // ////console.log(data.MayS - data.MayP,'rrde',data.MayS,data.MayP)
          // setmayprofit(Math.round(data.MayS));
          setjanuaryproft(Math.round(data.JanS || 0)); // Handle undefined values
          setfeburprofit(Math.round(data.FebS || 0));
          setmarchprofit(Math.round(data.MarchS || 0));
          setaprilprofit(Math.round(data.AprilS || 0));
          setmayprofit(Math.round(data.MayS || 0));
          setjuneprofit(Math.round(data.JuneS || 0));
          setjulyproft(Math.round(data.JulyS || 0));
          setaugprofit(Math.round(data.AugestS || 0));
          setsepprofit(Math.round(data.SeptS || 0));
          setoctprofit(Math.round(data.OctS || 0));
          setnovprofit(Math.round(data.NovS || 0));
          setdecprofit(Math.round(data.DecS || 0));
        }

        setallprofitcollections(res.data);
      });
  };

  // var options = {
  //   series: [{
  //     name: "Desktops",
  //     data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
  // }],
  //   chart: {
  //   height: 350,
  //   type: 'line',
  //   zoom: {
  //     enabled: false
  //   }
  // },
  // dataLabels: {
  //   enabled: false
  // },
  // stroke: {
  //   curve: 'straight'
  // },
  // title: {
  //   text: 'Product Trends by Month',
  //   align: 'left'
  // },
  // grid: {
  //   row: {
  //     colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
  //     opacity: 0.5
  //   },
  // },
  // xaxis: {
  //   categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
  // }
  // };

  // var chart = new ApexCharts(document.querySelector("#chart"), options);
  // chart.render();

  const series2 = [
    // {
    //   name: "No of SO",
    //   data: [januaryproft],
    // },
    {
      name: 'SI Value',
      data: [
        januaryproft,
        feburprofit,
        marchprofit,
        aprilprofit,
        mayprofit,
        juneprofit,
        julyproft,
        augprofit,
        sepprofit,
        octprofit,
        novprofit,
        decprofit,
      ],
    },
  ];
  const options2 = {
    chart: {
      toolbar: {
        show: !1,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: '45%',
        endingShape: 'rounded',
        barHeight: '100%',
      },
    },
    dataLabels: {
      enabled: !1,
    },
    stroke: {
      show: !0,
      width: 2,
      colors: ['transparent'],
    },
    series: [
      {
        data: [1.4, 2, 2.5, 1.5, 2.5, 2.8, 3.8, 4.6],
      },
      {
        data: [20, 29, 37, 36, 44, 45, 50, 58],
      },
    ],
    colors: ['#f1b44c', '#5b73e8', '#34c38f'],
    xaxis: {
      categories: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
    },
    yaxis: {
      title: {
        text: '',
      },
    },
    grid: {
      borderColor: '#f1f1f1',
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
  };

  const PoCount = async (id, id1) => {


    const Customerid = sessionStorage.getItem('Customer_Log');
    const Branchid = sessionStorage.getItem('Branch_Log');
    const userid = sessionStorage.getItem('Userid');
    const token = sessionStorage.getItem('AuthToken');
    // const purchases = await axios.instance
    //   .post(
    //     `/DashboardNew`,
    //     {
    //       "Admin": sessionStorage.getItem('AdminUser'),
    //       "Special_User1": sessionStorage.getItem('Special_User1'),
    //       // "PO_Access": sessionStorage.getItem('PO_ACCESS'),
    //       // "ALL_BRANCH": sessionStorage.getItem('ALL_BRANCH'),
    //       "DashStatus": "TotalPO",
    //       "Customer_Id": Customerid,
    //       "Cus_Branchid": Branchid,
    //       "FromDate": (moment(id).format('YYYYMMDD')),
    //       "Todate": (moment(id1).format('YYYYMMDD')),
    //       "User_Id": userid
    //     },

    //     {
    //       headers: { Authorization: token, 'Content-Type': 'application/json' },
    //     },
    //   )
    //   .then(res => {
    //     // for (const Data of res.data) {
    //     // setcompletecouts(res.data.length);
    //     setpendingcount(res.data.length);
    //     // }
    //   })
    // .then(async res => {
    // Confirmed PO
    const custoemrid = sessionStorage.getItem('Customer_Log');
    const purchases = await axios.instance
      .post(
        `/DashboardNew`,
        {
          "Admin": sessionStorage.getItem('AdminUser'),
          "Special_User1": sessionStorage.getItem('Special_User1'),
          // "PO_Access": sessionStorage.getItem('PO_ACCESS'),
          // "ALL_BRANCH": sessionStorage.getItem('ALL_BRANCH'),
          "DashStatus": "PORaise",
          "Customer_Id": Customerid,
          "Cus_Branchid": Branchid,
          "FromDate": (moment(id).format('YYYYMMDD')),
          "Todate": (moment(id1).format('YYYYMMDD')),
          "User_Id": userid
        },

        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        },
      )
      .then(res => {
        // for (const Data of res.data) {
        // setstatuscounsts(res.data.length);
        setcompletecouts(res.data.length);
        // }
      })
      // })
      .then(async res => {
        const custoemrid = sessionStorage.getItem('Customer_Log');
        const purchases = await axios.instance
          .post(
            `/DashboardNew`,
            {
              "Admin": sessionStorage.getItem('AdminUser'),
              "Special_User1": sessionStorage.getItem('Special_User1'),
              // "PO_Access": sessionStorage.getItem('PO_ACCESS'),
              // "ALL_BRANCH": sessionStorage.getItem('ALL_BRANCH'),
              "DashStatus": "Onnum",
              "Customer_Id": Customerid,
              "Cus_Branchid": Branchid,
              "FromDate": (moment(id).format('YYYYMMDD')),
              "Todate": (moment(id1).format('YYYYMMDD')),
              "User_Id": userid
            },

            {
              headers: { Authorization: token, 'Content-Type': 'application/json' },
            },
          )
          .then(res => {
            // for (const Data of res.data) {
            // setcompletecouts(res.data.length);
            setstatuscounsts(res.data.length);
            console.log(res.data.length, 'length')
            // }
          });
      })
       .then(async res => {
              const custoemrid = sessionStorage.getItem('Customer_Log');
              const purchases = await axios.instance
                .post(
                  `/DashboardNew`,
                  {
                    Admin: sessionStorage.getItem('AdminUser'),
                    Special_User1: sessionStorage.getItem('Special_User1'),
                    // "PO_Access": sessionStorage.getItem('PO_ACCESS'),
                    // "ALL_BRANCH": sessionStorage.getItem('ALL_BRANCH'),
                    DashStatus: 'Delivered',
                    Customer_Id: Customerid,
                    Cus_Branchid: Branchid,
                    FromDate: moment(id).format('YYYYMMDD'),
                    Todate: moment(id1).format('YYYYMMDD'),
                    User_Id: userid,
                  },
      
                  {
                    headers: {
                      Authorization: token,
                      'Content-Type': 'application/json',
                    },
                  },
                )
                .then(res => {
                  // for (const Data of res.data) {
                  // setstatuscounsts(res.data.length);
                  // setcompletecouts(res.data.length);
                  setdeliveredCounts(res.data.length);
                  
                  // }
                });
            })
  };

  // if (!chartOptions) return null;
  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <Row>
            <Col lg={12}>
              <Breadcrumbs breadcrumbItem="Dashboard" />
            </Col>
            {/* <Zoom in={true} style={{ transitionDelay: true ? '400ms' : '0ms' }}>
              <Col lg={4} className="my-3">
                <Card
                  style={{
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    minHeight: '200px',
                  }}
                  className="border-none text-white-50"
                >
                  <CardBody
                    style={{
                      color: '#4b4c4d',
                      backgroundColor: 'ghostwhite',
                      padding: 0,
                      margin: '3px',
                      borderRadius: '8px',
                      minHeight: '216px',
                    }}
                  >
                    <h5
                      className="m-0 font-size-30 "
                      style={{
                        fontWeight: 'bold',
                        color: 'white',
                        letterSpacing: '1px',
                        padding: '20px',
                        background:
                          '-webkit-linear-gradient(to right,#4389A2, #5C258D)',
                        background:
                          'linear-gradient(to right,  #4389A2, #5C258D)',
                        borderTopLeftRadius: 11,
                        borderTopRightRadius: 11,
                      }}
                    >
                      <i
                        className="fa-solid fa-boxes-stacked "
                        style={{ fontSize: '25px', color: 'white' }}
                      ></i>{' '}
                      Customers Enrolled
                    </h5>
                    <CardText className="font-size-12 mt-2 p-0 ">
                      <Row className="p-2">
                        <Col xs="12">
                          <p
                            style={{
                              fontWeight: '600',
                            }}
                          >
                            Access Given :{' '}
                            <span
                              style={{ fontSize: '16px', color: '#007C00' }}
                            >
                              {`${customerenrolleddata.enable_mis_count} out of ${customerenrolleddata.Customers_Count} customers`}
                            </span>
                          </p>
                        </Col>
                        <Col xs="6">
                          <p
                            style={{
                              fontWeight: '600',
                            }}
                          >
                            PO Create :{' '}
                            <span
                              style={{ fontSize: '16px', color: '#007C00' }}
                            >
                              {`${customerenrolleddata.enable_po_count} / ${customerenrolleddata.no_of_po_acc}`}
                            </span>
                          </p>
                        </Col>
                        <Col xs="6">
                          {' '}
                          <p
                            style={{
                              fontWeight: '600',
                            }}
                          >
                            Approvals :{' '}
                            <span
                              style={{ fontSize: '16px', color: '#007C00' }}
                            >
                              {`${customerenrolleddata.enable_approval_count} / ${customerenrolleddata.no_of_approve_acc}`}
                            </span>
                          </p>
                        </Col>
                        <Col xs="6">
                          <p
                            style={{
                              fontWeight: '600',
                            }}
                          >
                            Branches :{' '}
                            <span
                              style={{ fontSize: '16px', color: '#007C00' }}
                            >
                              {`${customerenrolleddata.enable_branch_count} / ${customerenrolleddata.no_of_branch_acc}`}
                            </span>
                          </p>
                        </Col>
                        <Col xs="6">
                          <p
                            style={{
                              fontWeight: '600',
                            }}
                          >
                            Inventory :{' '}
                            <span
                              style={{ fontSize: '16px', color: '#007C00' }}
                            >
                              {`${customerenrolleddata.enable_inventory_count} / ${customerenrolleddata.no_of_inv_acc}`}
                            </span>
                          </p>
                        </Col>
                      </Row>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Zoom> */}
            <Zoom in={true} style={{ transitionDelay: true ? '400ms' : '0ms' }}>
              <Col lg={3} className="my-3">
                <Card
                  style={{
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    minHeight: '200px',
                  }}
                  className="border-none text-white-50"
                >
                  <CardBody
                    style={{
                      color: '#4b4c4d',
                      backgroundColor: 'ghostwhite',
                      padding: 0,
                      margin: '3px',
                      borderRadius: '8px',
                      minHeight: '216px',
                    }}
                  >
                    <h5
                      className="m-0 font-size-30 "
                      style={{
                        fontWeight: 'bold',
                        fontSize: '16px',
                        color: 'white',
                        letterSpacing: '1px',
                        padding: '18px',
                        background:
                          '-webkit-linear-gradient(to right,#4389A2, #5C258D)',
                        background:
                          'linear-gradient(to right,  #4389A2, #5C258D)',
                        borderTopLeftRadius: 11,
                        borderTopRightRadius: 11,
                      }}
                    >
                      <i
                        className="fa-solid fa-boxes-stacked "
                        style={{ fontSize: '25px', color: 'white' }}
                      ></i>{' '}
                      Confirmed  PO
                    </h5>
                    <CardText className="font-size-12 mt-2 p-0 ">
                      <div className="m-2 p-2">
                        <p
                          style={{
                            fontWeight: '600',
                          }}
                        >
                          <span style={{ fontSize: '3rem', color: '#007C00' }}>
                            {format(completecouts)}
                          </span>
                        </p>
                      </div>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Zoom>
            <Zoom in={true} style={{ transitionDelay: true ? '400ms' : '0ms' }}>
              <Col lg={3} className="my-3">
                <Card
                  style={{
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    minHeight: '200px',
                  }}
                  className="border-none text-white-50"
                >
                  <CardBody
                    style={{
                      color: '#4b4c4d',
                      backgroundColor: 'ghostwhite',
                      padding: 0,
                      margin: '3px',
                      borderRadius: '8px',
                      minHeight: '216px',
                    }}
                  >
                    <h5
                      className="m-0 font-size-30 "
                      style={{
                        fontWeight: 'bold',
                        fontSize: '16px',
                        color: 'white',
                        letterSpacing: '1px',
                        padding: '18px',
                        background:
                          '-webkit-linear-gradient(to right,#4389A2, #5C258D)',
                        background:
                          'linear-gradient(to right,  #4389A2, #5C258D)',
                        borderTopLeftRadius: 11,
                        borderTopRightRadius: 11,
                      }}
                    >
                      <i
                        className="fa-solid fa-boxes-stacked "
                        style={{ fontSize: '25px', color: 'white' }}
                      ></i>{' '}
                      Outstanding
                    </h5>
                    <CardText className="font-size-12 mt-2 p-0 ">
                      <div className="m-2 p-2">
                        <p
                          style={{
                            fontWeight: '600',
                          }}
                        >
                          <span
                            style={{ fontSize: '2.5rem', color: '#007C00' }}
                          >
                            {format(salesoutstanding)}
                          </span>
                        </p>
                      </div>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Zoom>
            <Zoom in={true} style={{ transitionDelay: true ? '400ms' : '0ms' }}>
              <Col lg={3} className="my-3">
                <Card
                  style={{
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    minHeight: '200px',
                  }}
                  className="border-none text-white-50"
                >
                  <CardBody
                    style={{
                      color: '#4b4c4d',
                      backgroundColor: 'ghostwhite',
                      padding: 0,
                      margin: '3px',
                      borderRadius: '8px',
                      minHeight: '216px',
                    }}
                  >
                    <h5
                      className="m-0 font-size-30 "
                      style={{
                        fontWeight: 'bold',
                        fontSize: '16px',
                        color: 'white',
                        letterSpacing: '1px',
                        padding: '18px',
                        background:
                          '-webkit-linear-gradient(to right,#4389A2, #5C258D)',
                        background:
                          'linear-gradient(to right,  #4389A2, #5C258D)',
                        borderTopLeftRadius: 11,
                        borderTopRightRadius: 11,
                      }}
                    >
                      <i
                        className="fa-solid fa-boxes-stacked "
                        style={{ fontSize: '25px', color: 'white' }}
                      ></i>{' '}
                      PO Approval Pending
                    </h5>
                    <CardText className="font-size-12 mt-2 p-0 ">
                      <div className="m-2 p-2">
                        <p
                          style={{
                            fontWeight: '600',
                          }}
                        >
                          <span style={{ fontSize: '3rem', color: '#007C00' }}>
                            {format(statuscounsts)}
                          </span>
                        </p>
                      </div>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Zoom>
            {/* delivered */}
              <Zoom in={true} style={{ transitionDelay: true ? '400ms' : '0ms' }}>
              <Col lg={3} className="my-3">
                <Card
                  style={{
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    minHeight: '200px',
                  }}
                  className="border-none text-white-50"
                >
                  <CardBody
                    style={{
                      color: '#4b4c4d',
                      backgroundColor: 'ghostwhite',
                      padding: 0,
                      margin: '3px',
                      borderRadius: '8px',
                      minHeight: '216px',
                    }}
                  >
                    <h5
                      className="m-0 font-size-30 "
                      style={{
                        fontWeight: 'bold',
                        fontSize: '16px',
                        color: 'white',
                        letterSpacing: '1px',
                        padding: '18px',
                        background:
                          '-webkit-linear-gradient(to right,#4389A2, #5C258D)',
                        background:
                          'linear-gradient(to right,  #4389A2, #5C258D)',
                        borderTopLeftRadius: 11,
                        borderTopRightRadius: 11,
                      }}
                    >
                      <i
                        className="fa-solid fa-boxes-stacked "
                        style={{ fontSize: '25px', color: 'white' }}
                      ></i>{' '}
                      Delivered PO
                    </h5>
                    <CardText className="font-size-12 mt-2 p-0 ">
                      <div className="m-2 p-2">
                        <p
                          style={{
                            fontWeight: '600',
                          }}
                        >
                          <span style={{ fontSize: '3rem', color: '#007C00' }}>
                            {format(deliveredCounts)}
                          </span>
                        </p>
                      </div>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Zoom>
            {/* Client Requirement */}
            {/* <Zoom in={true} style={{ transitionDelay: true ? '400ms' : '0ms' }}>
              <Col lg={6} className="my-3">
                <Card
                  style={{
                    borderRadius: '8px',
                    backgroundColor: 'white',
                  }}
                  className="border-none text-white-50"
                >
                  <CardBody
                    style={{
                      color: '#4b4c4d',
                      backgroundColor: 'ghostwhite',
                      padding: 0,
                      margin: '3px',
                      borderRadius: '8px',
                    }}
                  >
                    <h5
                      className="m-0 font-size-30 "
                      style={{
                        fontWeight: 'bold',
                        color: 'white',
                        letterSpacing: '1px',
                        padding: '20px',

                        background: '#7F7FD5',
                        background:
                          '-webkit-linear-gradient(to right, #91EAE4, #86A8E7, #7F7FD5)',
                        background:
                          'linear-gradient(to right, #91EAE4, #86A8E7, #7F7FD5)',
                        borderTopLeftRadius: 11,
                        borderTopRightRadius: 11,
                      }}
                    >
                      <ReportGmailerrorredIcon
                        style={{
                          fontSize: '25px',
                          color: 'white',
                          marginRight: '2px',
                        }}
                      />
                      Top Selling Products
                    </h5>
                    <CardText className="font-size-12 mt-2 p-0 ">
                      <div
                        className="table-container"
                        style={{
                          minHeight: '250px',
                          maxHeight: '250px',
                          overflowY: 'scroll',
                        }}
                      >
                        <Table className="table-centered table-nowrap mb-0">
                          <tbody>
                            {alltopsellingproudcts.map((data, index) => (
                              <tr key={index}>
                                <td>
                                  <h6 className="font-size-15 mb-1 fw-normal">
                                    {data.Product_Details_Description}
                                  </h6>
                                  <p className="text-bold font-size-13 mb-0">
                                    {data.Brand}
                                  </p>
                                </td>
                                <td>
                                  <span className="badge bg-soft-success font-size-12">
                                    Active
                                  </span>
                                </td>
                                <td className="text-muted fw-semibold text-end">
                                  {format(data.Net_quantity)}
                                  {/* {numeral(data.Net_quantity).format('0.00')}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Zoom> */}
            {/* Client Requirement */}
            {/*             
            <Zoom in={true} style={{ transitionDelay: true ? '400ms' : '0ms' }}>
              <Col lg={6} className="my-3">
                <Card
                  style={{
                    borderRadius: '8px',
                    backgroundColor: 'white',
                  }}
                  className="border-none text-white-50"
                >
                  <CardBody
                    style={{
                      color: '#4b4c4d',
                      backgroundColor: 'ghostwhite',
                      padding: 0,
                      margin: '3px',
                      borderRadius: '8px',
                    }}
                  >
                    <h5
                      className="m-0 font-size-30 "
                      style={{
                        fontWeight: 'bold',
                        color: 'white',
                        letterSpacing: '1px',
                        padding: '20px',

                        background: '#8360c3',
                        background:
                          '-webkit-linear-gradient(to right, #2ebf91, #8360c3)',
                        background:
                          'linear-gradient(to right, #2ebf91, #8360c3)',
                        borderTopLeftRadius: 11,
                        borderTopRightRadius: 11,
                      }}
                    >
                      <ReportGmailerrorredIcon
                        style={{
                          fontSize: '25px',
                          color: 'white',
                          marginRight: '2px',
                        }}
                      />
                      Top Customers
                    </h5>
                    <CardText className="font-size-12 mt-2 p-0 ">
                      <div
                        className="table-container"
                        style={{
                          minHeight: '250px',
                          maxHeight: '250px',
                          overflowY: 'scroll',
                        }}
                      >
                        <Table className="table-borderless table-centered ">
                          <tbody>
                            {allusers.map((data, index) => (
                              <tr key={index}>
                                <td>
                                  <h6 className="font-size-15 mb-1 fw-normal">
                                    {data.Customer_Name}
                                  </h6>
                                  <p className="text-muted font-size-11 mb-0">
                                    <i
                                      className="mdi mdi-map-marker"
                                      style={{ color: 'red' }}
                                    ></i>{' '}
                                    {data.State}
                                  </p>
                                </td>
                                <td>
                                  <span className="badge bg-soft-success font-size-12">
                                    Active
                                  </span>
                                </td>
                                <td className="text-muted fw-semibold text-end">
                                  {format(data.Net_amount)}
                                  {/* {numeral(data.Net_amount).format('0,0.00')}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Zoom> */}

            {/* Apex Chart */}
            <Zoom in={true} style={{ transitionDelay: true ? '400ms' : '0ms' }}>
              <Col lg={12} className="my-3">
                <Card
                  style={{ borderRadius: '8px', backgroundColor: 'white' }}
                  className="border-none text-white-50"
                >
                  <CardBody
                    style={{
                      color: '#4b4c4d',
                      backgroundColor: 'ghostwhite',
                      padding: 0,
                      margin: '3px',
                      borderRadius: '8px',
                    }}
                  >
                    <h5
                      className="m-0 font-size-30"
                      style={{
                        fontWeight: 'bold',
                        color: 'white',
                        letterSpacing: '1px',
                        padding: '20px',
                        background: '#59C173',
                        background:
                          '-webkit-linear-gradient(to right, #5D26C1, #a17fe0, #59C173)',
                        background:
                          'linear-gradient(to right, #5D26C1, #a17fe0, #59C173)',
                        borderTopLeftRadius: 11,
                        borderTopRightRadius: 11,
                      }}
                    >
                      <ReportGmailerrorredIcon
                        style={{
                          fontSize: '25px',
                          color: 'white',
                          marginRight: '2px',
                        }}
                      />
                      Sales Analytics
                    </h5>

                    <div style={{ padding: '20px' }}>
                      <ReactApexChart
                        options={options2}
                        series={series2}
                        type="bar"
                        height={350}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Zoom>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  );
}

export default DashboardPG;
